import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Lock, Eye, EyeOff, Phone } from 'lucide-react';
import Header from './components/Header13';
import Footer from './components/Footer13';

const Signup13 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', password: '', confirmPassword: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/template13');
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px 14px 44px', border: '1px solid #E7E0D6', borderRadius: '4px',
        backgroundColor: '#FBF8F4', fontFamily: "'Mulish', sans-serif", fontSize: '14px',
        color: '#1C1917', outline: 'none', transition: 'border-color 0.3s',
    };

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&family=Mulish:wght@300;400;600&display=swap');`}</style>
            <div style={{ fontFamily: "'Mulish', sans-serif" }} className="min-h-screen bg-[#FBF8F4]">
                <Header />
                <main className="pt-20 min-h-screen flex">
                    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
                        <img src="https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Artisan at work" className="absolute inset-0 w-full h-full object-cover" />
                        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, transparent, rgba(251, 248, 244, 0.9))' }} />
                        <div className="relative z-10 flex flex-col justify-center items-start p-16 max-w-lg">
                            <div style={{ width: '48px', height: '3px', backgroundColor: '#C2410C', marginBottom: '24px' }} />
                            <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '36px', fontWeight: 700, color: '#1C1917', lineHeight: 1.2, marginBottom: '16px' }}>
                                Join the Artisan Community
                            </h2>
                            <p style={{ fontSize: '16px', color: '#78716C', lineHeight: 1.7 }}>
                                Create an account to discover handcrafted treasures from India's finest artisans.
                            </p>
                        </div>
                    </div>

                    <div className="flex-1 flex items-center justify-center px-6 py-12">
                        <div className="w-full max-w-md">
                            <div style={{ textAlign: 'center', marginBottom: '36px' }}>
                                <h1 onClick={() => navigate('/template13')} style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '28px', fontWeight: 700, color: '#C2410C', cursor: 'pointer', letterSpacing: '2px', marginBottom: '12px', textTransform: 'uppercase' }}>KARIGAR</h1>
                                <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '24px', fontWeight: 700, color: '#1C1917', marginBottom: '8px' }}>Create Account</h2>
                                <p style={{ fontSize: '14px', color: '#78716C' }}>Begin your artisan journey</p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                {[
                                    { name: 'name', type: 'text', placeholder: 'Full Name', icon: User },
                                    { name: 'email', type: 'email', placeholder: 'Email Address', icon: Mail },
                                    { name: 'phone', type: 'tel', placeholder: 'Phone Number', icon: Phone },
                                ].map(field => (
                                    <div key={field.name} style={{ marginBottom: '16px', position: 'relative' }}>
                                        <field.icon size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#78716C' }} />
                                        <input name={field.name} type={field.type} value={formData[field.name]} onChange={handleInputChange} placeholder={field.placeholder} style={inputStyle}
                                            onFocus={(e) => { e.target.style.borderColor = '#C2410C'; }} onBlur={(e) => { e.target.style.borderColor = '#E7E0D6'; }} />
                                    </div>
                                ))}
                                <div style={{ marginBottom: '16px', position: 'relative' }}>
                                    <Lock size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#78716C' }} />
                                    <input name="password" type={showPassword ? 'text' : 'password'} value={formData.password} onChange={handleInputChange} placeholder="Password" style={inputStyle}
                                        onFocus={(e) => { e.target.style.borderColor = '#C2410C'; }} onBlur={(e) => { e.target.style.borderColor = '#E7E0D6'; }} />
                                    <button type="button" onClick={() => setShowPassword(!showPassword)}
                                        style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}>
                                        {showPassword ? <EyeOff size={18} color="#78716C" /> : <Eye size={18} color="#78716C" />}
                                    </button>
                                </div>
                                <div style={{ marginBottom: '28px', position: 'relative' }}>
                                    <Lock size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#78716C' }} />
                                    <input name="confirmPassword" type="password" value={formData.confirmPassword} onChange={handleInputChange} placeholder="Confirm Password" style={inputStyle}
                                        onFocus={(e) => { e.target.style.borderColor = '#C2410C'; }} onBlur={(e) => { e.target.style.borderColor = '#E7E0D6'; }} />
                                </div>
                                <button type="submit"
                                    style={{ width: '100%', padding: '16px', backgroundColor: '#C2410C', color: '#FFFFFF', border: 'none', borderRadius: '4px', fontSize: '13px', fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer', minHeight: '52px', transition: 'all 0.3s' }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#9A3412'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C2410C'; }}>
                                    Create Account
                                </button>
                            </form>

                            <p style={{ textAlign: 'center', marginTop: '28px', fontSize: '14px', color: '#78716C' }}>
                                Already have an account?{' '}
                                <span onClick={() => navigate('/template13/login')} style={{ color: '#C2410C', fontWeight: 600, cursor: 'pointer' }}>Sign In</span>
                            </p>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Signup13;
